<template>
   <div class="stadium-monitor-wrapper">
      <div class="flex-row-between margin-bottom-10">
         <h3>摄像头</h3>
         <el-button type="primary" @click="clickAddCamera">添加</el-button>
      </div>
      <div class="camera-bezel">
         <div class="camera-item flex-column" v-for="(item, index) in cameraConfig" :key="index">
            <div class="flex-row-between margin-bottom-10">
               <el-select placeholder="请选择盒子" v-model="item.boxId" @change="handleConfigModel">
                  <el-option v-for="(device, deviceIndex) in deviceList" :key="deviceIndex" :label="device.uid"
                     :value="device.uid">
                  </el-option>
               </el-select>
               <el-button style="color: red;" type="text" @click="clickDeleteCamera(item)">删除</el-button>
            </div>
            <el-select class="margin-bottom-10" placeholder="请选择场馆" v-model="item.venueId" @change="handleConfigModel">
               <el-option v-for="(stadium, stadiumIndex) in stadiumList" :key="stadiumIndex" :label="stadium.areaName"
                  :value="stadium.areaId" :disabled="handleCameraStadiumDisabled(stadium.areaId, index)">
               </el-option>
            </el-select>
            <div class="input-bezel flex-row">
               <span>单次运动结束时间:&nbsp;</span>
               <el-input-number :controls="false" :min="0" v-model="item.sportTimeLimit"
                  @input="handleConfigModel"></el-input-number>
               <span>&nbsp;分钟</span>
            </div>
            <div class="tips-text">超过该时间未抓拍到新的照片，则结束该次运动生成一条运动记录</div>
            <div v-if="item.boxId">
               <el-upload class="upload-file" accept=".yaml" name="file" :show-file-list="false"
                  :action="$util.aioIP + '/api/m/sys/config/file/v365/upload'"
                  :headers="{ channelCode: $util.envType == 'pre' ? 'iydsjpre' : 'iydsj' }"
                  :data="{ schoolId: schoolId, uid: item.boxId, userName: $store.state.user.name }"
                  :on-success="handleSuccess" :on-error="handleError">
                  <el-button>选择上传文件</el-button>
               </el-upload>
               <div class="flex-row-around">
                  <span>{{ handleSelectedBoxInfo(item.boxId).fileName || '' }}</span>
                  <span>{{ handleSelectedBoxInfo(item.boxId).createTime || '' }}</span>
                  <span>{{ handleSelectedBoxInfo(item.boxId).uploader || '' }}</span>
               </div>
               <div class="flex-row-between">
                  <el-button type="text" @click="clickUploadConfigRecord(item)">查看上传记录</el-button>
                  <el-button type="text" @click="clickDownload(item)">下载</el-button>
               </div>
            </div>
         </div>
      </div>

      <div class="flex-row-between margin-top-20 margin-bottom-10">
         <div class="flex-row gap-10">
            <h3>是否启用闸机</h3>
            <el-switch on-text="" off-text="" v-model="openGateMachine" @change="handleConfigModel"></el-switch>
         </div>
         <el-button type="primary" v-if="openGateMachine" @click="clickAddBinding">
            添加绑定关系
         </el-button>
      </div>

      <div class="gate-bezel" v-if="openGateMachine">
         <div class="gate-item flex-row gap-10" v-for="(item, index) in gateMachineConfig" :key="index">
            <el-input placeholder="请输入闸机采集模块序列号" v-model="item.gateMachineId" @input="handleConfigModel"></el-input>
            <span>绑定</span>
            <el-select placeholder="请选择场馆" v-model="item.venueId" @change="handleConfigModel">
               <el-option v-for="(stadium, stadiumIndex) in stadiumList" :key="stadiumIndex" :label="stadium.areaName"
                  :value="stadium.areaId" :disabled="handleGateMachineStadiumDisabled(stadium.areaId, index)">
               </el-option>
            </el-select>
            <el-select class="direction-select" v-model="item.direction" @change="handleConfigModel">
               <el-option label="进" :value="1"></el-option>
               <el-option label="出" :value="2"></el-option>
            </el-select>
            <el-button style="color: red;" type="text" @click="clickDeleteGate(item)">删除</el-button>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   props: {
      schoolId: {
         type: String,
         default: ''
      },
      configModel: {
         type: Object,
         default: () => ({})
      }
   },

   data() {
      return {
         deviceList: [],
         stadiumList: [],
         cameraConfig: [],
         openGateMachine: false,
         gateMachineConfig: [],
      }
   },

   watch: {
      schoolId(value) {
         this.queryDeviceList();
         this.queryStadiumList();
      },

      configModel(value) {
         this.cameraConfig = value.cameraConfig || [];
         this.openGateMachine = value.openGateMachine == 1;
         this.gateMachineConfig = value.gateMachineConfig || [];
      }
   },

   methods: {
      // 查询硬件防作弊设备配置列表
      queryDeviceList() {
         this.$http({
            url: this.$util.aioIP + '/api/m/sys/config/file/v365/list',
            method: 'get',
            params: { schoolId: this.schoolId, type: 9 },
            headers: { channelCode: this.$util.envType == 'pre' ? 'iydsjpre' : 'iydsj' },
         }).then((res) => {
            this.deviceList = res.data.data || [];
         }).catch((err) => {
            this.deviceList = [];
         });
      },

      // 获取场馆列表
      queryStadiumList() {
         this.$http({
            url: this.$util.domain + '/adminapi/v1/basicTools/sportmonitor/areaList',
            method: 'get',
            params: { rootUnid: this.schoolId },
         }).then((res) => {
            this.stadiumList = res.data.data || [];
         }).catch((err) => {
            this.stadiumList = [];
         })
      },

      // 点击删除场馆摄像头
      clickDeleteCamera(item) {
         this.cameraConfig.splice(this.cameraConfig.indexOf(item), 1);
         this.handleConfigModel();
      },

      // 点击添加场馆摄像头
      clickAddCamera() {
         if (this.cameraConfig.some((item) => item.venueId === '')) {
            this.$message.error('请先选择场馆');
            return;
         }
         let availableStadium = [];
         if (this.openGateMachine) {
            availableStadium = this.stadiumList.filter(item => {
               return !this.gateMachineConfig.some(gateItem => gateItem.venueId === item.venueId);
            });
         } else {
            availableStadium = this.stadiumList;
         }
         if (this.cameraConfig.length < availableStadium.length) {
            this.cameraConfig.push({
               venueId: '',
               venueName: '',
               boxId: "",
               sportTimeLimit: 0,
            })
         } else {
            this.$message.error('暂无更多场馆');
         }
         this.handleConfigModel();
      },

      // 上传成功
      handleSuccess(res, file, fileList) {
         this.queryDeviceList();
      },

      // 上传失败
      handleError(err) {
         this.$message.error('上传失败');
      },

      // 点击下载
      clickDownload(item) {
         if (!item.boxId) return {};
         const device = this.deviceList.find((device) => device.uid === item.boxId);
         if (device) {
            location.href = this.$util.aioIP + '/file' + device.filePath;
         }
      },

      // 点击查看上传记录
      clickUploadConfigRecord(item) {
         if (!item.boxId) return {};
         const device = this.deviceList.find((device) => device.uid === item.boxId);
         if (device) {
            this.$emit('click-record', device);
         }
      },

      // 点击删除场馆闸机
      clickDeleteGate(item) {
         this.gateMachineConfig.splice(this.gateMachineConfig.indexOf(item), 1);
         this.handleConfigModel();
      },

      // 点击添加绑定关系
      clickAddBinding() {
         if (this.gateMachineConfig.some((item) => item.gateMachineId === '')) {
            this.$message.error('请输入闸机采集模块序列号');
            return;
         }
         const availableStadium = this.stadiumList.filter(item => {
            return !this.cameraConfig.some(cameraItem => cameraItem.venueId === item.venueId);
         });
         if (availableStadium.length > 0) {
            this.gateMachineConfig.push({
               venueId: '',
               venueName: '',
               gateMachineId: '',
               direction: 1,
            })
         } else {
            this.$message.error('暂无更多场馆');
         }
         this.handleConfigModel();
      },

      // 处理摄像头可选场馆是否禁用
      handleCameraStadiumDisabled(venueId, cameraIndex) {
         if (this.cameraConfig[cameraIndex].venueId === venueId) {
            return false;
         }
         if (this.gateMachineConfig.some((item) => item.venueId === venueId)) {
            return true;
         }
         if (this.cameraConfig.some((item) => item.venueId === venueId)) {
            return true;
         }
         return false;
      },

      // 处理闸机可选场馆是否禁用
      handleGateMachineStadiumDisabled(venueId, cameraIndex) {
         if (this.cameraConfig.some((item) => item.venueId === venueId)) {
            return true;
         }
         return false;
      },

      // 处理当前选择的盒子信息
      handleSelectedBoxInfo(boxId) {
         if (!boxId) return {};
         const device = this.deviceList.find((item) => item.uid === boxId);
         return device ? device : {};
      },

      // 处理model数据
      handleConfigModel() {
         const cameraConfig = this.cameraConfig.map((item) => {
            const stadium = this.stadiumList.find((stadiumItem) => stadiumItem.areaId === item.venueId);
            return {
               boxId: item.boxId,
               venueId: item.venueId,
               venueName: stadium ? stadium.areaName : '',
               sportTimeLimit: item.sportTimeLimit,
            }
         })
         const gateMachineConfig = this.gateMachineConfig.map((item) => {
            const stadium = this.stadiumList.find((stadiumItem) => stadiumItem.areaId === item.venueId);
            return {
               gateMachineId: item.gateMachineId,
               venueId: item.venueId,
               venueName: stadium ? stadium.areaName : '',
               direction: item.direction,
            }
         })
         const sportTimeConfigModel = {
            openVenueSport: this.configModel.openVenueSport,
            cameraConfig: cameraConfig,
            openGateMachine: this.openGateMachine,
            gateMachineConfig: gateMachineConfig,
         };
         this.$emit('update:configModel', sportTimeConfigModel);
      }

   }
}
</script>

<style scoped>
.stadium-monitor-wrapper {
   width: 100%;
}

.camera-bezel {
   display: flex;
   flex-direction: column;
   gap: 10px;
}

.camera-item {
   padding: 20px 20px 10px 20px;
   box-sizing: border-box;
   width: 100%;
   background-color: #e8e8e8;
}

.camera-item .el-select {
   width: 88%;
}

.camera-item .tips-text {
   font-size: 11px;
   color: #999999;
}

.camera-item .upload-file {
   width: 88%;
}

.upload-file .el-button {
   width: 100%;
   height: 36px;
}

.camera-item .sperate-line {
   margin: 10px 0px 20px 0px;
   height: 1px;
   background-color: #e8e8e8;
}

.gate-bezel {
   display: flex;
   flex-direction: column;
   gap: 10px;
}

.gate-item {
   padding: 20px;
   box-sizing: border-box;
   width: 100%;
   background-color: #e8e8e8;
}

.gate-item .el-input {
   flex: 1;
}

.gate-item .el-select {
   flex: 1;
}

.gate-item .direction-select {
   max-width: 15%;
}
</style>


// WEBPACK FOOTER //
// StadiumMonitor.vue?94aef524